import * as React from 'react';
import { useEffect, useState } from 'react';
import * as _ from 'lodash';
import AsyncSelect from 'react-select/async';
import { observer } from 'mobx-react';
import { styled, Theme } from '../theme';
import { OrganizationModel } from '@journeyapps-platform/lib-journey-core';
import { useSystem } from '../hooks/useSystem';
import { useOrgStore } from '../hooks/useOrgStore';
import { EvaluateSelectStyles } from '../widgets/select/SelectWidget';
import { useTheme } from '@emotion/react';
import { Routes, useJourneyNavigation } from '../routes';

export interface SmartOrgSelectWidgetProps {
  className?: any;
}

export const SmartOrgSelectWidget: React.FC<SmartOrgSelectWidgetProps> = observer((props) => {
  const system = useSystem();
  const orgStore = useOrgStore();
  const theme = useTheme() as Theme;
  const { navigate } = useJourneyNavigation(Routes.MANAGE_APPS);

  React.useEffect(() => {
    orgStore.loadUserOrgs();
  }, []);

  const transformOrgs = (orgs: OrganizationModel[]) => {
    return orgs.map((org) => {
      return {
        ...org.model,
        value: org.id
      };
    });
  };

  const orgs = _.chain(orgStore.models)
    .values()
    .sortBy((orgModel) => orgModel.options.model.label)
    .value();

  const selectStyles = EvaluateSelectStyles(theme, { hideDropdownIndicator: orgs.length == 1 });
  return (
    <div key={orgStore.current_org?.model?.label} className={props.className}>
      <AsyncSelect
        placeholder="Select org"
        blurInputOnSelect={true}
        onChange={(e) => {
          navigate(Routes.ADMIN_HOME, { org_id: (e as any).id });
        }}
        value={orgStore.current_org?.model}
        defaultOptions={transformOrgs(orgs)}
        loadOptions={async (input) => {
          const res = await system.accountV5Client.searchOrgs({ search: input });
          const vals = res.objects.map((res) => orgStore.generate(res));
          return transformOrgs(vals);
        }}
        styles={
          {
            ...selectStyles,
            control: (provided: any, state: any) => ({
              ...selectStyles?.control?.(provided, state),
              ':hover': {
                border: 'solid 1px #444444'
              },
              background: theme.header.orgSelect,
              border: 'solid 1px #2e2e2e',
              fontWeight: 'bold'
            })
          } as any
        }
      />
    </div>
  );
});
